"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../../Button");
require("./Buttons.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Buttons = _ref => {
  var className = _ref.className,
    _ref$isPrimaryButtonA = _ref.isPrimaryButtonActive,
    isPrimaryButtonActive = _ref$isPrimaryButtonA === void 0 ? false : _ref$isPrimaryButtonA,
    _ref$isSecondaryButto = _ref.isSecondaryButtonActive,
    isSecondaryButtonActive = _ref$isSecondaryButto === void 0 ? false : _ref$isSecondaryButto,
    onClickPrimaryButton = _ref.onClickPrimaryButton,
    onClickSecondaryButton = _ref.onClickSecondaryButton,
    _ref$primaryButtonTex = _ref.primaryButtonText,
    primaryButtonText = _ref$primaryButtonTex === void 0 ? 'Continue' : _ref$primaryButtonTex,
    _ref$secondaryButtonT = _ref.secondaryButtonText,
    secondaryButtonText = _ref$secondaryButtonT === void 0 ? 'Cancel' : _ref$secondaryButtonT;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('zui-wizard-buttons', className)
  }, onClickSecondaryButton && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    color: _Button.Color.Red,
    isDisabled: !isSecondaryButtonActive,
    onPress: onClickSecondaryButton
  }, secondaryButtonText), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    isDisabled: !isPrimaryButtonActive,
    onPress: onClickPrimaryButton
  }, primaryButtonText));
};
exports.Buttons = Buttons;
//# sourceMappingURL=Buttons.js.map